import React from "react";
import Solution from "./components/Solution";

const Problem4 = () => {
  return (
    <div className="p-4">
      <h1 className="">Problem 4</h1>
      <p className="">
        <div className="">Create a Tooltip component.</div>
      </p>
      <Solution />
    </div>
  );
};

export default Problem4;
